// API =>
// import backEnd from "../../store/Api";
// import { useUserStore } from "../../store/useUserStore";

export async function ProfileEditor(
    userId: number,
    nameInputValue: string,
    lastNameInputValue: string,
    phoneNumberInputValue: string,
    addressInputValue: string,
    postalCodeInputValue: string,
    emailAddressInputValue: string,
) {
    // backEnd.patch(`//?pk=${ userId }/`, {
    //     name: nameInputValue,
    //     last_name: lastNameInputValue,
    //     phone_number: phoneNumberInputValue,
    //     address: addressInputValue,
    //     postal_code: postalCodeInputValue,
    //     email_address: emailAddressInputValue,
    // }, {
    //     headers: {
    //         Authorization: `Token ${localStorage.getItem("Token")}`,
    //         "Content-Type": "application/json",
    //     }
    // }).then(( result ) => {
    //     console.log(result);
    // }).catch(( error ) => {
    //     console.log(error);
    // })
}

// export const provinceOptions = [
//     { title: "تهران", value: "تهران" },
//     { title: "خراسان رضوی", value: "خراسان رضوی" },
//     { title: "اصفهان", value: "اصفهان" },
//     { title: "فارس", value: "فارس" },
//     { title: "خوزستان", value: "خوزستان" },
//     { title: "آذربایجان شرقی", value: "آذربایجان شرقی" },
//     { title: "مازندران", value: "مازندران" },
//     { title: "آذربایجان غربی", value: "آذربایجان غربی" },
//     { title: "کرمان", value: "کرمان" },
//     { title: "سیستان و بلوچستان", value: "سیستان و بلوچستان" },
//     { title: "البرز", value: "البرز" },
//     { title: "گیلان", value: "گیلان" },
//     { title: "کرمانشاه", value: "کرمانشاه" },
//     { title: "لرستان", value: "لرستان" },
//     { title: "کردستان", value: "کردستان" },
//     { title: "گلستان", value: "گلستان" },
//     { title: "هرمزگان", value: "هرمزگان" },
//     { title: "همدان", value: "همدان" },
//     { title: "قم", value: "قم" },
//     { title: "مرکزی", value: "مرکزی" },
//     { title: "اردبیل", value: "اردبیل" },
//     { title: "قزوین", value: "قزوین" },
//     { title: "یزد", value: "یزد" },
//     { title: "زنجان", value: "زنجان" },
//     { title: "بوشهر", value: "بوشهر" },
//     { title: "چهارمحال و بختیاری", value: "چهارمحال و بختیاری" },
//     { title: "خراسان شمالی", value: "خراسان شمالی" },
//     { title: "کهگیلویه و بویراحمد", value: "کهگیلویه و بویراحمد" },
//     { title: "سمنان", value: "سمنان" },
//     { title: "ایلام", value: "ایلام" },
//     { title: "خراسان جنوبی", value: "خراسان جنوبی" }
// ];


export const citiesOption: Record<string, { title: string; value: string }[]> = {
  "تهران": [
    { title: "تهران", value: "تهران" },
    { title: "اسلام‌شهر", value: "اسلام‌شهر" },
    { title: "شهریار", value: "شهریار" },
    { title: "ری", value: "ری" },
    { title: "قدس", value: "قدس" },
    { title: "پاکدشت", value: "پاکدشت" },
    { title: "ملارد", value: "ملارد" },
    { title: "پردیس", value: "پردیس" },
    { title: "رودهن", value: "رودهن" },
    { title: "دماوند", value: "دماوند" },
    { title: "شمیرانات", value: "شمیرانات" },
    { title: "باقرشهر", value: "باقرشهر" },
  ],

  "خراسان رضوی": [
    { title: "مشهد", value: "مشهد" },
    { title: "نیشابور", value: "نیشابور" },
    { title: "سبزوار", value: "سبزوار" },
    { title: "تربت‌جام", value: "تربت‌جام" },
    { title: "تربت‌حیدریه", value: "تربت‌حیدریه" },
    { title: "قوچان", value: "قوچان" },
    { title: "کاشمر", value: "کاشمر" },
    { title: "گناباد", value: "گناباد" },
    { title: "بردسکن", value: "بردسکن" },
    { title: "چناران", value: "چناران" },
  ],

  "اصفهان": [
    { title: "اصفهان", value: "اصفهان" },
    { title: "کاشان", value: "کاشان" },
    { title: "خمینی‌شهر", value: "خمینی‌شهر" },
    { title: "نجف‌آباد", value: "نجف‌آباد" },
    { title: "شهرضا", value: "شهرضا" },
    { title: "گلپایگان", value: "گلپایگان" },
    { title: "فلاورجان", value: "فلاورجان" },
    { title: "نایین", value: "نایین" },
  ],

  "فارس": [
    { title: "شیراز", value: "شیراز" },
    { title: "مرودشت", value: "مرودشت" },
    { title: "فسا", value: "فسا" },
    { title: "کازرون", value: "کازرون" },
    { title: "جهرم", value: "جهرم" },
    { title: "لار", value: "لار" },
    { title: "داراب", value: "داراب" },
    { title: "سپیدان", value: "سپیدان" },
  ],

  "خوزستان": [
    { title: "اهواز", value: "اهواز" },
    { title: "آبادان", value: "آبادان" },
    { title: "خرمشهر", value: "خرمشهر" },
    { title: "ماهشهر", value: "ماهشهر" },
    { title: "دزفول", value: "دزفول" },
    { title: "مسجدسلیمان", value: "مسجدسلیمان" },
    { title: "اندیمشک", value: "اندیمشک" },
  ],

  "آذربایجان شرقی": [
    { title: "تبریز", value: "تبریز" },
    { title: "مراغه", value: "مراغه" },
    { title: "مرند", value: "مرند" },
    { title: "اهر", value: "اهر" },
    { title: "شبستر", value: "شبستر" },
    { title: "بناب", value: "بناب" },
  ],

  "مازندران": [
    { title: "ساری", value: "ساری" },
    { title: "آمل", value: "آمل" },
    { title: "بابل", value: "بابل" },
    { title: "قائم‌شهر", value: "قائم‌شهر" },
    { title: "چالوس", value: "چالوس" },
    { title: "نوشهر", value: "نوشهر" },
    { title: "تنکابن", value: "تنکابن" },
  ],

  "آذربایجان غربی": [
    { title: "ارومیه", value: "ارومیه" },
    { title: "خوی", value: "خوی" },
    { title: "میاندوآب", value: "میاندوآب" },
    { title: "مهاباد", value: "مهاباد" },
    { title: "بوکان", value: "بوکان" },
    { title: "سلماس", value: "سلماس" },
  ],

  "کرمان": [
    { title: "کرمان", value: "کرمان" },
    { title: "رفسنجان", value: "رفسنجان" },
    { title: "سیرجان", value: "سیرجان" },
    { title: "جیرفت", value: "جیرفت" },
    { title: "بم", value: "بم" },
  ],

  "سیستان و بلوچستان": [
    { title: "زاهدان", value: "زاهدان" },
    { title: "چابهار", value: "چابهار" },
    { title: "زابل", value: "زابل" },
    { title: "ایرانشهر", value: "ایرانشهر" },
    { title: "خاش", value: "خاش" },
  ],

  "البرز": [
    { title: "کرج", value: "کرج" },
    { title: "نظرآباد", value: "نظرآباد" },
    { title: "فردیس", value: "فردیس" },
    { title: "اشتهارد", value: "اشتهارد" },
  ],

  "گیلان": [
    { title: "رشت", value: "رشت" },
    { title: "انزلی", value: "انزلی" },
    { title: "لنگرود", value: "لنگرود" },
    { title: "لاهیجان", value: "لاهیجان" },
    { title: "تالش", value: "تالش" },
  ],

  "کرمانشاه": [
    { title: "کرمانشاه", value: "کرمانشاه" },
    { title: "اسلام‌آباد غرب", value: "اسلام‌آباد غرب" },
    { title: "جوانرود", value: "جوانرود" },
    { title: "قصر شیرین", value: "قصر شیرین" },
  ],

  "لرستان": [
    { title: "خرم‌آباد", value: "خرم‌آباد" },
    { title: "بروجرد", value: "بروجرد" },
    { title: "دورود", value: "دورود" },
    { title: "الیگودرز", value: "الیگودرز" },
  ],

  "کردستان": [
    { title: "سنندج", value: "سنندج" },
    { title: "سقز", value: "سقز" },
    { title: "بانه", value: "بانه" },
    { title: "مریوان", value: "مریوان" },
  ],

  "گلستان": [
    { title: "گرگان", value: "گرگان" },
    { title: "گنبد", value: "گنبد" },
    { title: "علی‌آباد کتول", value: "علی‌آباد کتول" },
    { title: "آق‌قلا", value: "آق‌قلا" },
  ],

  "هرمزگان": [
    { title: "بندرعباس", value: "بندرعباس" },
    { title: "قشم", value: "قشم" },
    { title: "بندرلنگه", value: "بندرلنگه" },
    { title: "میناب", value: "میناب" },
  ],

  "همدان": [
    { title: "همدان", value: "همدان" },
    { title: "ملایر", value: "ملایر" },
    { title: "نهاوند", value: "نهاوند" },
    { title: "بهار", value: "بهار" },
  ],

  "قم": [
    { title: "قم", value: "قم" }
  ],

  "مرکزی": [
    { title: "اراک", value: "اراک" },
    { title: "ساوه", value: "ساوه" },
    { title: "خمین", value: "خمین" },
  ],

  "اردبیل": [
    { title: "اردبیل", value: "اردبیل" },
    { title: "مشگین‌شهر", value: "مشگین‌شهر" },
    { title: "پارس‌آباد", value: "پارس‌آباد" },
  ],

  "قزوین": [
    { title: "قزوین", value: "قزوین" },
    { title: "البرز", value: "البرز" },
    { title: "آبیک", value: "آبیک" }
  ],

  "یزد": [
    { title: "یزد", value: "یزد" },
    { title: "میبد", value: "میبد" },
    { title: "اردکان", value: "اردکان" },
  ],

  "زنجان": [
    { title: "زنجان", value: "زنجان" },
    { title: "ابهر", value: "ابهر" },
    { title: "خدابنده", value: "خدابنده" },
  ],

  "بوشهر": [
    { title: "بوشهر", value: "بوشهر" },
    { title: "برازجان", value: "برازجان" },
    { title: "کنگان", value: "کنگان" },
  ],

  "چهارمحال و بختیاری": [
    { title: "شهرکرد", value: "شهرکرد" },
    { title: "بروجن", value: "بروجن" },
    { title: "فارسان", value: "فارسان" },
  ],

  "خراسان شمالی": [
    { title: "بجنورد", value: "بجنورد" },
    { title: "شیروان", value: "شیروان" },
    { title: "اسفراین", value: "اسفراین" },
  ],

  "کهگیلویه و بویراحمد": [
    { title: "یاسوج", value: "یاسوج" },
    { title: "دوگنبدان", value: "دوگنبدان" },
    { title: "دهدشت", value: "دهدشت" },
  ],

  "سمنان": [
    { title: "سمنان", value: "سمنان" },
    { title: "شاهرود", value: "شاهرود" },
    { title: "دامغان", value: "دامغان" }
  ],

  "ایلام": [
    { title: "ایلام", value: "ایلام" },
    { title: "دهلران", value: "دهلران" },
    { title: "دره‌شهر", value: "دره‌شهر" }
  ],

  "خراسان جنوبی": [
    { title: "بیرجند", value: "بیرجند" },
    { title: "طبس", value: "طبس" },
    { title: "فردوس", value: "فردوس" }
  ]
};

export const provinceOptions = Object.keys(citiesOption).map((p) => ({
  title: p,
  value: p
}));
